import Vue from 'vue';
import BrandingTransform from '@/transforms/Branding';
import FeedbackProxy from '@/proxies/Feedback';
import InfoProxy from '@/proxies/Info';
import safelySwitchTheme from '@/utils/safely-switch-theme';
import {
  INIT_SETUP,
  INIT_ROUTER,
  INIT_HTTP,
  INIT_THEME,
} from '@/constants';
import * as types from './mutation-types';
import download from '@/utils/download';

export default {
  async copyToClipboard({ dispatch }, payload) {
    console.log(window, navigator);
    if (navigator?.clipboard) {
      await navigator.clipboard.writeText(payload);
      dispatch('notification/success', 'confirmationmessage.text_copied', { root: true });
      return;
    }
    const body = document.querySelector('body');
    const area = document.createElement('textarea');
    body.appendChild(area);
    area.value = payload;
    area.select();
    document.execCommand('copy');
    body.removeChild(area);
    dispatch('notification/success', 'confirmationmessage.text_copied', { root: true });
    // dispatch('notification/error', 'errormessage.not_supported', { root: true });
  },
  downloadAction({ dispatch, getters }, payload) {
    dispatch('notification/success', 'confirmationmessage.download_starts_soon', { root: true });
    download(`${getters.baseUrlPath}/api/v1/${payload}`);
  },
  async getFrameFeedbackTypes({ commit, dispatch }) {
    const proxy = new FeedbackProxy();
    try {
      const response = await proxy.getFrameFeedbackTypes();
      commit(types.SET_FRAMES_FEEDBACK, response.types);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_frames_feedback', { root: true });
    }
  },
  async getTrackFeedbackTypes({ commit, dispatch }) {
    const proxy = new FeedbackProxy();
    try {
      const response = await proxy.getTrackFeedbackTypes();
      commit(types.SET_TRACKS_FEEDBACK, response.types);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_tracks_feedback', { root: true });
    }
  },
  async getInfo({ commit, dispatch }) {
    try {
      const proxy = new InfoProxy();
      const response = await proxy.getInfo();
      commit(types.SET_INFO, response);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_server_info', { root: true });
    }
  },
  initSetup({ commit }) {
    commit(types.APPLICATION_STAGE, INIT_SETUP);
  },
  initHttp({ commit }) {
    commit(types.APPLICATION_STAGE, INIT_HTTP);
  },
  initRouter({ commit }) {
    commit(types.APPLICATION_STAGE, INIT_ROUTER);
  },
  initTheme({ commit }) {
    commit(types.APPLICATION_STAGE, INIT_THEME);
  },
  async setting({ commit, dispatch }) {
    try {
      const setting = {
        base_url: '/',
        base_url_path: '',
      }
      commit(types.SET_SETTING, setting);
      dispatch('initSetup');
    } catch (e) {
      Vue.router.push({
        name: Vue.$app.route.ERROR,
        params: { error: 'system_error' },
      });
    }
  },
  async branding({ dispatch }) {
    dispatch('setBranding', { color_scheme: 'default', home_url: 'https://www.inter.it/en' });   // 'red_fire_brick'
  },
  async setBranding({ commit, dispatch }, payload) {
    const brand = BrandingTransform.fetch(payload);
    commit(types.SET_BRANDING, brand);
    await safelySwitchTheme(brand.theme);
    dispatch('initTheme');
  },
  setLanguage({ commit }, payload) {
    commit(types.SET_LANGUAGE, payload.toLowerCase());
  },
};
